import { APP_INITIALIZER, ErrorHandler, Provider } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { initReplayTokenGate } from './replay-token-gate';

/** Nothing to run: depending on TraceService is what constructs it, and constructing it subscribes it to the router. */
export function initSentryTracing(): () => void {
	return () => undefined;
}

/**
 * Sentry's Angular integration. Without these, an error zone.js catches stops at Angular's
 * default ErrorHandler (console only), and router navigations are never spans, because the
 * Angular browserTracingIntegration sets instrumentNavigation:false and relies on TraceService.
 *
 * createErrorHandler() keeps logErrors:true (the console output stays) and showDialog:false (no
 * Sentry report dialog in front of the user). With Sentry disabled there is no client and the
 * handler only logs to the console, as the default one did.
 */
export const SENTRY_PROVIDERS: Provider[] = [
	{provide: ErrorHandler, useValue: Sentry.createErrorHandler()},
	// TraceService is providedIn: 'root' but only exists once something injects it.
	{provide: APP_INITIALIZER, useFactory: initSentryTracing, deps: [Sentry.TraceService], multi: true},
	// Keeps Session Replay off while the URL carries a reset or SSO token.
	{provide: APP_INITIALIZER, useFactory: initReplayTokenGate, deps: [Router], multi: true},
];
